module.exports = __webpack_public_path__ + "static/media/pic_jan.acb45ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic_jan.jpg
// module id = 56
// module chunks = 0